import { render, staticRenderFns } from "./PrimaryPhoneNumberRegistrationSuccess.vue?vue&type=template&id=0a6cac99&"
import script from "./PrimaryPhoneNumberRegistrationSuccess.vue?vue&type=script&lang=js&"
export * from "./PrimaryPhoneNumberRegistrationSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports